module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_clock.521c1.png";